// DS: i3.10
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import IconWrap from '../../IconWrap';
const Share = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M5 16v2a1 1 0 01-.883.993L4 19a1 1 0 01-1-1v-2a8 8 0 018-8h1V3.562c0-.28.204-.511.471-.555L12.562 3h.144a1 1 0 01.613.21l.1.088 7.294 7.41a1 1 0 01.279.571l.008.13v.215a1 1 0 01-.174.564l-.073.095-7.33 8.376a1 1 0 01-.63.333l-.122.008h-.108a.563.563 0 01-.556-.471L12 20.438V16H5zm9-6h-3a6.102 6.102 0 00-1.431.172l-.324.089c-.14.043-.28.09-.415.144l-.304.127-.221.106-.216.114-.175.101-.122.076-.318.216-.079.058a6.024 6.024 0 00-.284.228l-.135.118-.205.195-.188.195-.129.144-.163.199-.136.179-.12.17-.14.213-.113.192-.115.213-.15.309-.147.363-.029.08L14 14v2.962l4.735-5.412L14 6.74V10z"
    })));
Share.displayName = 'Share';
export default Share;
